import React, { useContext } from 'react';

import { OpenModalContext } from 'common/containers/ModalContainer';
import LazyLoadedImage from 'common/LazyLoadedImage';

import PhotoViewer from '../PhotoViewer';
import Tappable from '../Tappable';

import type { Comment } from 'common/api/resources/comments';

import 'css/components/comment/_CommentImages.scss';

type Props = {
  urls: Comment['imageURLs'];
};

const CommentImages = ({ urls }: Props) => {
  const openModal = useContext(OpenModalContext);

  const onImageClicked = (index: number) => {
    openModal(PhotoViewer, {
      defaultIndex: index,
      imageURLs: urls,
    });
  };

  if (!urls.length) {
    return null;
  }

  const images = [];
  for (let i = 0; i < urls.length; i++) {
    const imageURL = urls[i];
    images.push(
      <Tappable key={imageURL} onTap={() => onImageClicked(i)}>
        <LazyLoadedImage src={imageURL} />
      </Tappable>
    );
  }

  return <div className="commentImages">{images}</div>;
};
export default CommentImages;
